import { findMarketGroupByCategory } from './findMarketGroupByCategory';
import { getIsSelectionActive } from './getIsSelectionActive';
import { matchSelections } from './matchSelections';
export const modifySlipSelections = (selectionsInSlip, byoMarketGroups) => {
    const modifiedSelections = {};
    const missingSelections = new Set();
    for (const [key, selection] of Object.entries(selectionsInSlip)) {
        const marketGroup = findMarketGroupByCategory(byoMarketGroups, selection.category);
        if (marketGroup) {
            const isSelectionActive = getIsSelectionActive(marketGroup, selection);
            modifiedSelections[key] = Object.assign(Object.assign({}, selection), { active: isSelectionActive });
        }
        else {
            modifiedSelections[key] = selection;
            missingSelections.add(key);
        }
    }
    if (missingSelections.size) {
        const [matchedSelections] = matchSelections(missingSelections, [], byoMarketGroups);
        matchedSelections.forEach(selection => {
            modifiedSelections[selection.id] = selection;
        });
    }
    return modifiedSelections;
};
